import {
    format,
    ISO_DATE_ONLY_FORMAT,
    zodDateOfBirthValidation,
} from '@fruitful/fruitils';
import { zodResolver } from '@hookform/resolvers/zod';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { Keyboard } from 'react-native';
import {
    BodyMediumRegular,
    ControlledDateTextInput,
    Form,
    H5Emphasized,
    isWeb,
    Private,
    View,
    YStack,
} from 'smoothie';
import { z } from 'zod';

import type { RunKYCVerifyBody } from '../../../hooks/kyc/useRunKycVerify';
import KycButton from './KycButton';

const dobSchema = z.object({
    dob: zodDateOfBirthValidation,
});

type DobSchema = z.infer<typeof dobSchema>;

interface DobProps {
    onPressNext: (formData?: Partial<RunKYCVerifyBody>) => void;
}

const Dob = ({ onPressNext }: DobProps) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<DobSchema>({
        resolver: zodResolver(dobSchema),
        defaultValues: {
            dob: '',
        },
    });

    const onSubmit: SubmitHandler<DobSchema> = ({ dob }) => {
        onPressNext({
            dateOfBirth: `${format(dob, ISO_DATE_ONLY_FORMAT)}T00:00:00Z`,
        });
    };

    return (
        <Private>
            <YStack
                flex={1}
                justifyContent={isWeb ? 'flex-start' : 'space-between'}
            >
                <View>
                    <H5Emphasized marginBottom={8}>
                        What&apos;s your date of birth?
                    </H5Emphasized>
                    <BodyMediumRegular color="$gray900" marginBottom={24}>
                        We&apos;re required to collect this to verify your
                        identity.
                    </BodyMediumRegular>
                </View>
                <View>
                    <Form onSubmit={handleSubmit(onSubmit)} marginBottom={12}>
                        <ControlledDateTextInput
                            name="dob"
                            control={control}
                            register={register}
                            errors={errors}
                            onSubmitEditing={() => {
                                Keyboard.dismiss();
                            }}
                        />
                    </Form>
                    <KycButton
                        onPress={handleSubmit(onSubmit)}
                        disabled={!isValid}
                        hideSecureText
                    />
                </View>
            </YStack>
        </Private>
    );
};

export default Dob;
